import { Injectable } from '@angular/core';
import { AzureStorageAPIService } from '../API/AzureStorageAPI.service';
@Injectable({
    providedIn: 'root'
  })


export class AzureStorageService{
  private configUrl: string;

  constructor(
    private azureStorageService: AzureStorageAPIService){}
  
  GetFileUrl( folderPath : string, fileName : string){
    return this.azureStorageService.GetFileUrl(folderPath, fileName);
  }

  GetFolderFilesUrl( folderPath : string){
    return this.azureStorageService.GetFolderFilesUrl(folderPath);
  }
}
